
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../config";

function PostListing() {
  const navigate = useNavigate();

  // ===== STATE =====
  const [suburb, setSuburb] = useState("");
  const [state, setState] = useState("");
  const [postcode, setPostcode] = useState("");

  const [accessType, setAccessType] = useState("Access Available Anytime");
  const [streetParking, setStreetParking] = useState(false);
  const [schoolZone, setSchoolZone] = useState(false);
  const [hasDogs, setHasDogs] = useState(false);
  const [greenBin, setGreenBin] = useState(false);

  const [serviceDay, setServiceDay] = useState("any");
  const [serviceTime, setServiceTime] = useState("any");

  const [time, setTime] = useState("");
  const [frequency, setFrequency] = useState("fortnightly");
  const [rideOnOrPush, setRideOnOrPush] = useState("Push");
  const [bagMulch, setBagMulch] = useState("Mulch");

  const [frontLawn, setFrontLawn] = useState(false);
  const [rearLawn, setRearLawn] = useState(false);
  const [natureStrip, setNatureStrip] = useState(false);
  const [acreage, setAcreage] = useState(false);

  const [newClient, setNewClient] = useState(false);
const [longTermClient, setLongTermClient] = useState(false);

  const [cutValue, setCutValue] = useState("");
  const [price, setPrice] = useState("");
  const [promoCode, setPromoCode] = useState("");

  const [disclaimerAccepted, setDisclaimerAccepted] = useState(false);
  const [message, setMessage] = useState("");

  // ===== FIXED FIELDS =====
  const category = "lawn_mowing";

  const type = "Sell";
  const title = "Lawn Mowing";

  


// ===== SUBMIT =====
const handleSubmit = async (e) => {
  e.preventDefault();
  setMessage("");

  try {
    const token = localStorage.getItem("token");
    const user = JSON.parse(localStorage.getItem("user"));
    const userId = user?.id;

    if (!userId) {
      setMessage("❌ Missing user ID. Please log in again.");
      return;
    }

    const payload = {
      title,
      category,
      type,
      suburb,
      state,
      postcode,
      accessType,
      serviceDay,
      serviceTime,
      streetParking,
      schoolZone,
      hasDogs,
      greenBin,
      frontLawn,
      rearLawn,
      natureStrip,
      acreage,
      newClient,
      longTermClient,
      rideOnOrPush,
      bagMulch,
      time,
      frequency,
      cutValue,
      price,
      promoCode,
      disclaimerAccepted,
      email: user.email,
    };

    setMessage("⏳ Redirecting to Stripe to activate your listing...");

    const feeRes = await fetch(`${API_BASE_URL}/api/payment/create-listing-fee`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });

    const feeData = await feeRes.json();

    console.log("LISTING FEE RESPONSE:", feeData);

if (feeData.promoApplied || feeData.free) {
  navigate(`/promotion-activation-success?listingId=${feeData.listingId || ""}`);
  return;
}

if (!feeRes.ok) {
  setMessage(`❌ ${feeData.error || feeData.message || "Could not start listing flow."}`);
  return;
}

if (!feeData.url) {
  console.log("LISTING FEE RESPONSE:", feeData);
  setMessage(`❌ ${feeData.error || feeData.message || "Could not start Stripe checkout session."}`);
  return;
}

window.location.href = feeData.url;
  } catch (err) {
    console.error("❌ Stripe listing fee error:", err);
    setMessage("❌ Stripe error. Please try again.");
  }
};



  // ===== UI =====
  return (
    <div style={containerStyle}>
      <h2 style={headerTitle}>Post Listing</h2>

      {message && (
        <div
          style={{
            marginBottom: "20px",
            textAlign: "center",
            color: message.includes("❌") ? "#d32f2f" : "#2e7d32",
            fontWeight: 600,
          }}
        >
          {message}
        </div>
      )}

      <form onSubmit={handleSubmit} style={formStyle}>
        {/* ===== LOCATION ===== */}
        <h3 style={sectionHeader}>Location</h3>

        <label style={boldLabel}>Suburb:</label>
        <input
          type="text"
          placeholder="Suburb"
          value={suburb}
          onChange={(e) => {
            const value = e.target.value;
            if (/^[a-zA-Z\s]*$/.test(value) || value === "") setSuburb(value);
          }}
          required
          style={inputStyle}
        />

        <label style={boldLabel}>State:</label>
        <select
          value={state}
          onChange={(e) => setState(e.target.value)}
          required
          style={selectStyle}
        >
          <option value="">Select State</option>
          <option value="VIC">Victoria</option>
          <option value="NSW">New South Wales</option>
          <option value="QLD">Queensland</option>
          <option value="SA">South Australia</option>
          <option value="WA">Western Australia</option>
          <option value="TAS">Tasmania</option>
          <option value="NT">Northern Territory</option>
          <option value="ACT">Australian Capital Territory</option>
        </select>

        <label style={boldLabel}>Postcode:</label>
        <input
          type="number"
          placeholder="Postcode"
          value={postcode}
          onChange={(e) => setPostcode(e.target.value)}
          required
          style={inputStyle}
        />

        {/* ===== ACCESS & PARKING ===== */}
        <h3 style={sectionHeaderBlue}>Access & Parking</h3>

        <label style={boldLabel}>Access Type:</label>
        <select
          value={accessType}
          onChange={(e) => setAccessType(e.target.value)}
          required
          style={selectStyle}
        >
          <option value="">Select Access Type</option>
          <option value="Access Available Anytime">Access Available Anytime</option>
          <option value="Access Requires Client to Be Home">
            Access Requires Client to Be Home
          </option>
          <option value="Access via Key or Gate Code">Access via Key or Gate Code</option>
        </select>

        <label style={labelStyle}>
          <input
            type="checkbox"
            checked={streetParking}
            onChange={(e) => setStreetParking(e.target.checked)}
          />
          Street Parking Available
        </label>

        <label style={labelStyle}>
          <input
            type="checkbox"
            checked={schoolZone}
            onChange={(e) => setSchoolZone(e.target.checked)}
          />
          Located in a School Zone
        </label>

        <label style={labelStyle}>
          <input
            type="checkbox"
            checked={hasDogs}
            onChange={(e) => setHasDogs(e.target.checked)}
          />
          Does the client have dogs?
        </label>

        <label style={labelStyle}>
          <input
            type="checkbox"
            checked={greenBin}
            onChange={(e) => setGreenBin(e.target.checked)}
          />
          Is there a green bin available?
        </label>

        {/* ===== PREFERRED SERVICE ===== */}
        <h3 style={sectionHeader}>Preferred Service</h3>

        <label style={boldLabel}>Preferred Day:</label>
        <select
          value={serviceDay}
          onChange={(e) => setServiceDay(e.target.value)}
          required
          style={selectStyle}
        >
          <option value="any">Any Day</option>
          <option value="monday">Monday</option>
          <option value="tuesday">Tuesday</option>
          <option value="wednesday">Wednesday</option>
          <option value="thursday">Thursday</option>
          <option value="friday">Friday</option>
           <option value="saturday">Saturday</option>
          <option value="sunday">Sunday</option>
        </select>

        <label style={boldLabel}>Preferred Time:</label>
        <select
          value={serviceTime}
          onChange={(e) => setServiceTime(e.target.value)}
          required
          style={selectStyle}
        >
          <option value="any">Any reasonable time</option>
          <option value="am">Morning (AM)</option>
          <option value="pm">Afternoon (PM)</option>
        </select>

        {/* ===== JOB DETAILS ===== */}
        <h3 style={sectionHeader}>Job Details</h3>

        <label style={boldLabel}>Estimated Time:</label>
        <select
          value={time}
          onChange={(e) => setTime(e.target.value)}
          required
          style={selectStyle}
        >
          <option value="">Select Duration</option>
          <option value="0.5">30 Minutes</option>
          <option value="1">1 Hour</option>
          <option value="1.5">1 Hour 30 Minutes</option>
          <option value="2">2 Hours</option>
          <option value="3">3 Hours</option>
        </select>

        <label style={boldLabel}>Growing Season Frequency:</label>
        <p
  style={{
    fontSize: "0.85rem",
    color: "#666",
    marginTop: "-10px",
    marginBottom: "5px",
  }}
>
  Select the usual mowing frequency during the main growing season.
</p>
        <select
          value={frequency}
          onChange={(e) => setFrequency(e.target.value)}
          required
          style={selectStyle}
        >
          <option value="weekly">Weekly</option>
          <option value="fortnightly">Fortnightly</option>
          <option value="3weeks">Every 3 Weeks</option>
          <option value="monthly">Monthly</option>
        </select>

        <label style={boldLabel}>Mower Type:</label>
        <select
          value={rideOnOrPush}
          onChange={(e) => setRideOnOrPush(e.target.value)}
          style={selectStyle}
        >
          <option value="Push">Push</option>
          <option value="Ride-on">Ride-on</option>
        </select>

        <label style={boldLabel}>Grass Handling:</label>
        <select
          value={bagMulch}
          onChange={(e) => setBagMulch(e.target.value)}
          style={selectStyle}
        >
          <option value="Mulch">Mulch</option>
          <option value="Bag">Bag</option>
        </select>

        {/* ===== AREAS SERVICED ===== */}
        <h3 style={sectionHeader}>Areas Serviced</h3>

        <label style={labelStyle}>
          <input
            type="checkbox"
            checked={frontLawn}
            onChange={(e) => setFrontLawn(e.target.checked)}
          />
          Front Lawn
        </label>

        <label style={labelStyle}>
          <input
            type="checkbox"
            checked={rearLawn}
            onChange={(e) => setRearLawn(e.target.checked)}
          />
          Rear Lawn
        </label>

        <label style={labelStyle}>
          <input
            type="checkbox"
            checked={natureStrip}
            onChange={(e) => setNatureStrip(e.target.checked)}
          />
          Nature Strip
        </label>

        <label style={labelStyle}>
  <input
    type="checkbox"
    checked={acreage}
    onChange={(e) => setAcreage(e.target.checked)}
  />
  Acreage Property
</label>

        {/* ===== CLIENT HISTORY ===== */}
<h3 style={sectionHeader}>Client History</h3>

<label style={labelStyle}>
  <input
    type="checkbox"
    checked={newClient}
    onChange={(e) => {
      const checked = e.target.checked;
      setNewClient(checked);
      if (checked) setLongTermClient(false);
    }}
  />
  New client (under 6 months)
</label>

<label style={labelStyle}>
  <input
    type="checkbox"
    checked={longTermClient}
    onChange={(e) => {
      const checked = e.target.checked;
      setLongTermClient(checked);
      if (checked) setNewClient(false);
    }}
  />
  Long-term client (12+ months)
</label>

        {/* ===== PRICING ===== */}
        <h3 style={sectionHeaderOrange}>Pricing</h3>

        <label style={boldLabel}>Cut Value ($):</label>
        <input
          type="number"
          placeholder="Cut Value"
          value={cutValue}
          onChange={(e) => setCutValue(e.target.value)}
          required
          style={inputStyle}
        />

        <label style={boldLabel}>Sale Price ($):</label>
        <input
          type="number"
          placeholder="Sale Price"
          value={price}
          onChange={(e) => setPrice(e.target.value)}
          required
          style={inputStyle}
        />

        <label style={boldLabel}>Promo / Invite Code (Optional):</label>
<input
  type="text"
  placeholder="Optional"
  value={promoCode}
  onChange={(e) => setPromoCode(e.target.value)}
  style={inputStyle}
/>

        {/* ===== DISCLAIMER ===== */}
       <label style={labelStyle}>
  <input
    type="checkbox"
    checked={disclaimerAccepted}
    onChange={(e) => setDisclaimerAccepted(e.target.checked)}
    required
  />
  I confirm that:
</label>

<ul style={{ fontSize: "0.9rem", color: "#333", marginTop: "8px", marginLeft: "25px" }}>
  <li>All information provided is accurate and not misleading</li>
  <li>I am solely responsible for this listing</li>
  <li>Client Exchange™ does not verify or guarantee listing information</li>
  <li>I have authority to transfer these clients</li>
  <li>This does not breach any agreement (including franchise or contractual obligations)</li>
  <li>
  I agree to be bound by the Client Exchange™ terms,
  conditions, and policies listed on the website from time to time
</li>
</ul>

<p style={{ fontSize: "0.8rem", color: "#666", marginTop: "8px" }}>
  Listings must comply with any applicable agreements or obligations held by the seller.
</p>

        <button type="submit" style={buttonStyle}>Submit Listing</button>
      </form>
    </div>
  );
}

// ===== STYLES =====
const containerStyle = {
  maxWidth: "95%",
  width: "600px",
  margin: "50px auto",
  padding: "25px",
  backgroundColor: "#fff",
  borderRadius: "12px",
  boxShadow: "0 4px 15px rgba(0,0,0,0.15)",
};

const headerTitle = {
  textAlign: "center",
  marginBottom: "25px",
  color: "#2e7d32",
};

const formStyle = { display: "flex", flexDirection: "column", gap: "18px" };

const inputStyle = {
  padding: "10px",
  borderRadius: "6px",
  border: "1px solid #ccc",
  fontSize: "1rem",
  width: "100%",
};

const selectStyle = { ...inputStyle };

const labelStyle = {
  display: "flex",
  alignItems: "center",
  gap: "10px",
  fontSize: "0.95rem",
  flexWrap: "wrap",
};

const boldLabel = { fontWeight: "bold" };

const sectionHeader = { borderBottom: "2px solid #4caf50", paddingBottom: "5px" };
const sectionHeaderBlue = { borderBottom: "2px solid #0288d1", paddingBottom: "5px" };
const sectionHeaderOrange = { borderBottom: "2px solid #ff9800", paddingBottom: "5px" };

const buttonStyle = {
  padding: "16px",
  backgroundColor: "#4caf50",
  color: "#fff",
  fontWeight: "bold",
  border: "none",
  borderRadius: "8px",
  cursor: "pointer",
  fontSize: "1rem",
  transition: "0.3s",
};

buttonStyle[":hover"] = { backgroundColor: "#388e3c" };

export default PostListing;